<template>
    <kendo-window ref="createWindow"
                  :minWidth="700"
                  :append-to="'#spark-app'"
                  :width="700"
                  :height="850"
                  :modal="true"
                  :maximize-button="false"
                  :minimize-button="false"
                  :resizable="true"
                  v-if="visible"
                  :title="$t('customers.create-contact')"
                  @close="onWindowClosed"
                  @activate="onWindowActivated">

        <ValidationObserver v-slot="{ invalid }">
            <form role="form">

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('customers.internal-contact')}}</label>
                    <div class="col-md-6">
                        <kendo-switch
                            :messages="switchInternalMessages"
                            :width="'70'"
                            :checked="form.is_internal"
                            @change="onInternalContactSwitchChange"
                        ></kendo-switch>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.first-name')}} *</label>

                    <div class="col-md-6" v-if="!formdisabled">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input ref="firstInput" type="text" class="form-control" name="first_name" v-model="form.first_name" >
                            <span>{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="col-md-6" v-if="formdisabled">
                        <input :disabled="formdisabled" ref="firstInput" type="text" class="form-control" name="first_name" v-model="form.first_name" >
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.name')}} *</label>

                    <div class="col-md-6" v-if="!formdisabled">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input type="text" class="form-control" name="last_name" v-model="form.last_name">
                            <span>{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="col-md-6" v-if="formdisabled">
                        <input :disabled="formdisabled" type="text" class="form-control" name="last_name" v-model="form.last_name">
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.email')}} *</label>
                    <div class="col-md-6" v-if="!formdisabled">
                        <ValidationProvider rules="required|email" v-slot="{ errors }">
                            <input type="email" class="form-control" name="email" v-model="form.email">
                            <span>{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="col-md-6" v-if="formdisabled">
                        <input :disabled="formdisabled" type="email" class="form-control" name="email" v-model="form.email">
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.phone')}}</label>

                    <div class="col-md-6">
                        <input :disabled="formdisabled" type="tel" class="form-control" name="phone" v-model="form.phone">
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.company')}}</label>

                    <div class="col-md-6">
                        <input :disabled="formdisabled" type="text" class="form-control" name="company" v-model="form.company">
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.department')}}</label>

                    <div class="col-md-6">
                        <input :disabled="formdisabled" type="text" class="form-control" name="department" v-model="form.department">
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.location')}}</label>

                    <div class="col-md-6">
                        <input :disabled="formdisabled" type="text" class="form-control" name="location" v-model="form.location">
                    </div>
                </div>

                <div v-if="!form.is_internal" key="addressBlock">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">{{$t('address.street')}} *</label>
                        <div class="col-md-6" v-if="!formdisabled">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <input type="text" class="form-control" name="address" v-model="form.address">
                                <span>{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6" v-if="formdisabled">
                            <input :disabled="formdisabled" type="text" class="form-control" name="address" v-model="form.address">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">{{$t('address.city')}} *</label>
                        <div class="col-md-6" v-if="!formdisabled">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <input type="text" class="form-control" name="city" v-model="form.city">
                                <span>{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6" v-if="formdisabled">
                            <input :disabled="formdisabled" type="text" class="form-control" name="city" v-model="form.city">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">{{$t('address.zip')}} *</label>
                        <div class="col-md-6" v-if="!formdisabled">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <input type="text" class="form-control" name="zip" v-model="form.zip">
                                <span>{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6" v-if="formdisabled">
                            <input :disabled="formdisabled" type="text" class="form-control" name="zip" v-model="form.zip">
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.country')}} *</label>
                    <div class="col-md-6" v-if="!formdisabled">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input type="text" class="form-control" name="country" v-model="form.country">
                            <span>{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="col-md-6" v-if="formdisabled">
                        <input :disabled="formdisabled" type="text" class="form-control" name="country" v-model="form.country">
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.language')}} *</label>
                    <div class="col-md-6" v-if="!formdisabled">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <select v-model="form.locale" class="form-control">
                                <option value="" disabled>{{ $t('general.please_choose') }}</option>
                                <option value="de">Deutsch</option>
                                <option value="en">English</option>
                            </select>
                            <span>{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="col-md-6" v-if="formdisabled">
                        <input :disabled="formdisabled" type="text" class="form-control" name="locale" v-model="form.locale">
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{$t('address.additional-info')}}</label>

                    <div class="col-md-6">
                        <textarea :disabled="formdisabled" class="form-control" name="additional_info" v-model="form.additional_info"></textarea>
                    </div>
                </div>

                <div class="form-group row mb-0">
                    <div class="col-md-6 offset-md-4">
                        <button :disabled="invalid" type="submit" class="btn btn-primary" v-if="mode == 'create'"
                                @click.prevent="createObject">
                            {{$t('buttons.create')}}
                        </button>
                        <button :disabled="invalid" type="submit" class="btn btn-primary" v-if="mode == 'edit'"
                                @click.prevent="editObject">
                            {{$t('buttons.edit')}}
                        </button>
                        <button type="submit" class="btn btn-primary" v-if="mode == 'display'"
                                @click.prevent="goBack">
                            {{$t('buttons.back')}}
                        </button>
                    </div>
                </div>
            </form>
        </ValidationObserver>
    </kendo-window>
</template>

<script>
    export default {
        name: "window-create-customer",
        props: {
            visible: Boolean,
            emailAdress:String,
            user: String,
            customerid: Number,
            formdisabled: {
                default: false,
                type: Boolean
            }
        },
        data: function () {
            return {
                mode: 'create',
                switchInternalMessages: {
                    checked: this.$t('general.bool_true'),
                    unchecked: this.$t('general.bool_false')
                },
                form:{
                    email: '',
                    locale: '',
                    is_internal: false
                },
                loadedData: false
            }
        },
        mounted () {
            this.init();
        },
        methods: {
            init: function () {

                // Laden eines bestehenden Auftrags
                if (this.customerid) {
                    if (this.formdisabled) {
                        this.mode = "display";
                    } else {
                        this.mode = "edit";
                    }

                    axios
                        .get('/api/customers/id/' + this.customerid)
                        .then(response => {
                            this.loadedData = response.data;
                            console.log("GOT DATA:", this.loadedData);
                            this.prepareEditData();
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                        .finally(() => {
                        })
                } else {
                    this.mode = "create";
                }

            },

            /**
             * Nimmt Daten von außerhalb entgegen um die Felder vorzudefinieren
             * z.B. {email: 'test@example.com'}
             **/
            setData: function(data){
                this.form = Object.assign(this.form, data);
            },

            onInternalContactSwitchChange:function(e){
                console.log("changing switch" ,e);
                this.form.is_internal = e.value;
            },

            /**
             * Bereitet die geladenen Daten für die Edit-Maske vor
             */
            prepareEditData: function () {
                // Formulardaten setzen
                this.form = this.loadedData;
            },

            /**
             * Bereitet die Daten zum senden vor
             */
            prepareData(){
            },

            /**
             * Sendet die Formulardaten zum Server und versucht den Kontakt anzulegen
             */
            /*
            createObject() {
                this.prepareData();
                // Daten senden
                this.sendForm('post', '/api/customers', this.form)
                    .then(() => {
                        this.$emit('object-created');
                    });
            },*/

            /**
             * Sendet die Formulardaten zum Server und versucht den Kontakt zu bearbeiten
             */
            editObject() {
                // Daten senden
                this.sendForm('put', '/api/customers/update/' + this.form.id, this.form)
                    .then(() => {
                        this.$emit('object-updated');
                    });
            },

            goBack() {
                window.location.href = '/customers';
            },

            sendForm(method, uri, form) {
                return new Promise((resolve, reject) => {
                    axios[method](uri, JSON.parse(JSON.stringify(form)))
                        .then(response => {
                            swal.fire({
                                title: this.$t('customers.popup-contact-created-success-title'),
                                text: this.$t('customers.popup-contact-created-success-text'),
                                icon: "success",
                                timer: 1500
                            });
                            resolve(response.data);
                        })
                        .catch(errors => {
                            this.hideWindow();
                            swal.fire({
                                title: this.$t('customers.popup-contact-created-error-title'),
                                text: this.$t('customers.popup-contact-created-error-text'),
                                icon: "error"
                            });

                            reject(errors.response.data);
                        });
                });
            },

            hideWindow(){
                this.resetForm();
                this.$emit('closed');
            },

            resetForm(){
                this.form = {};
            },

            onWindowActivated(){
                this.$refs.firstInput.focus();
            },

            onWindowClosed(){
                this.hideWindow();
            },

            /**
             * Sendet die Formulardaten zum Server und versucht den Kontakt anzulegen
             */
            createObject() {
                this.prepareData();
                // Daten senden
                this.sendForm('post', '/api/customers', this.form)
                    .then((e) => {
                        this.resetForm();
                        this.$emit('customer-created', e, this.form);
                        this.$emit('closed');
                    });
            },
        }
    }
</script>

<style scoped>

</style>
